import { Navigate } from "react-router-dom";
import { useAuth } from "../context/AuthContext";
import { ROUTES } from "./sectionConfig";

/**
 * Redirects authenticated user to the default route for their role.
 * Used for /app index route.
 */
export default function RoleBasedRedirect() {
  const { userType } = useAuth();

  if (userType === "doctor") {
    return <Navigate to={ROUTES.doctorHome} replace />;
  }
  if (userType === "company") {
    return <Navigate to={ROUTES.home} replace />;
  }

  return <Navigate to="/login" replace />;
}
